exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".OnboardingStepRect {\n  position: absolute;\n  z-index: 40;\n  box-shadow: 0 0 0 9999px rgba(11, 28, 49, 0.75);\n  pointer-events: none; }\n", ""]);

// exports
